import { jsx as _jsx } from "preact/jsx-runtime";
import { configureStore } from '@reduxjs/toolkit';
import { storeOptions } from '@widgets/WalletWrapper/store';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { OptionsCTX, optionsDefaults } from '@widgets/WalletWrapper/context/Options';
import { Suspense, useContext, useMemo, } from 'preact/compat';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import { Provider } from 'react-redux';
import Wallet from '@widgets/shared/components/Wallet';
import { useAppDispatch, useAppSelector } from '@widgets/WalletWrapper/store/hooks';
import { getWalletAppleState, getWalletGoogleState, setWalletState } from '@widgets/WalletWrapper/store/reducers/wallet';
function Element() {
    const { analyticsTitle, analyticsUrl, analyticsPath, products, title, } = useContext(OptionsCTX);
    const appleHidden = useAppSelector(getWalletAppleState);
    const googleHidden = useAppSelector(getWalletGoogleState);
    const dispatch = useAppDispatch();
    // useEffect(() => {
    //   dispatchEvent(new CustomEvent('apple.wallet.failed'));
    //   dispatchEvent(new CustomEvent('google.wallet.failed'));
    // }, []);
    if (appleHidden && googleHidden) {
        return null;
    }
    return (_jsx("div", { className: "slab", children: _jsx(Wallet, { analyticsPath: analyticsPath, analyticsUrl: analyticsUrl, analyticsTitle: analyticsTitle, products: products ?? [], appleHidden: appleHidden, googleHidden: googleHidden, title: title, handleAppleDidFail: (status) => dispatch(setWalletState('apple', status)), handleGoogleDidFail: (status) => dispatch(setWalletState('google', status)) }) }));
}
function WalletWrapper(props) {
    const { dataset } = props;
    const store = configureStore(storeOptions);
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
    }), [formattedAttributes]);
    return (_jsx(Suspense, { fallback: LoadingSpinner, children: _jsx(Provider, { store: store, children: _jsx(OptionsCTX.Provider, { value: formOptions, children: _jsx(Element, {}) }) }) }));
}
export default WalletWrapper;
